module.exports = __webpack_public_path__ + "static/media/logo.030087cb.png";